export default __webpack_public_path__ + "static/cyber-threat-intelligence-8138d452fc5786e1aaa4bb72f0a24f9b.png";